import * as Yup from 'yup';

export const AddDocumentSchema = Yup.object({
    files: Yup.array().min(1, 'Please select at least one file').required('Please select at least one file'),

    // name: Yup.string().trim().required('This field is required'),
});
